import _ from 'lodash'
import React, { useState } from 'react'
import {
  PreviewSkeletonType
  // SkeletonConfigType
} from 'src/lib/types/uiPreview'
import Pill from './Pill'

interface LoadingListProps {
  length: number
  skeleton: PreviewSkeletonType
}

const LoadingList: React.FC<LoadingListProps> = ({ length, skeleton }) => {
  return (
    <>
      {_.times(length, (index: number) => {
        return (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: skeleton.layout,
              justifyContent: skeleton.justify,
              padding: '1rem',
              width: '100%',
              border: '1px solid #f0f0f0',
              borderRadius: '16px',
              gap: 6
            }}
          >
            {skeleton?.config?.map((item: any, index: number) => {
              return <Pill height={item?.height} width={item?.width} key={index} />
            })}
          </div>
        )
      })}
    </>
  )
}

export default LoadingList
